type AvatarSource = {
  avatarFile?: { url?: string | null } | null;
  legacyFileUrl?: string | null;
};

/**
 * Resolve a user's avatar URL from the raw domain avatar fields: prefer the
 * uploaded storage file, fall back to the legacy URL, otherwise null.
 * Centralizes the `avatarFile?.url ?? legacyFileUrl ?? null` rule that
 * consumers apply at render time on domain reference types.
 */
export const resolveAvatarUrl = (source: AvatarSource | null | undefined): string | null =>
  source?.avatarFile?.url ?? source?.legacyFileUrl ?? null;

/**
 * Adapt a legacy resolved `avatar` string (carried by the GraphQL `User` type)
 * into the raw `AvatarFields` shape that the display components consume. Used at
 * the few boundaries where a GraphQL `User` flows into an `AvatarFields` sink.
 */
export const legacyAvatarFields = (
  avatar: string | null
): {
  avatarFile: { url: string | null; fileId: string | null } | null;
  legacyFileUrl: string | null;
} => ({
  avatarFile: null,
  legacyFileUrl: avatar,
});
